module.exports = __webpack_public_path__ + "img/tab-route-navigator.dfb4d798.svg";